import { call, put } from 'redux-saga/effects';
import { takeEvery } from 'redux-saga';
import config from '../../config';
import request from 'superagent';

// Get the accounting of a book
export function* fetch_accounting() {
    yield* takeEvery("ACCOUNTING/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {                
                return request.get(`${config.apiEndpoint}/api/v4/accounting/book/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { accounting, auxiliar_accountings } = result;                
                yield put({ type: 'ACCOUNTING/SET', accounting });
                yield put({ type: 'ACCOUNTING/AUXILIAR/SET', auxiliar_accountings });
            } else {
                yield put({
                    type: 'ACCOUNTING/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'ACCOUNTING/FETCH_FAILED',
                e
            });
        }
    });
}

// Get the payment methods of a book
export function* fetch_payment_methods() {
    yield* takeEvery("PAYMENT_METHODS/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {                     
                return request.get(`${config.apiEndpoint}/api/v4/accounting/payment_methods/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { payment_methods } = result;                
                yield put({ type: 'PAYMENT_METHODS/SET', payment_methods });
            } else {
                yield put({
                    type: 'PAYMENT_METHODS/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'PAYMENT_METHODS/FETCH_FAILED',
                e
            });
        }
    });
}


export function* fetch_charges_report() {
    yield* takeEvery("REPORTS/CHARGES/FETCH", function* (action) {
        try {
            const result = yield call(({ IdProperty, Day }) => {
                return request.get(`${config.apiEndpoint}/api/v4/accounting/charges/${IdProperty}`)
                    .query({ day: Day })
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { charges } = result;
                yield put({ type: 'CHARGES/REPORT/SET', charges });
            } else {
                yield put({ type: 'REPORTS/CHARGES/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'REPORTS/CHARGES/FETCH_FAILED', e });
        }
    });
}

export function* fetch_booking() {
    yield* takeEvery("BOOKING/FETCH", function* (action) {
        try {
            const result = yield call(({ id }) => {                
                return request.get(`${config.apiEndpoint}/api/v4/bookings/${id}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { book } = result;
                yield put({ type: 'BOOK/SET', book });
            } else {
                yield put({
                    type: 'BOOKING/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'BOOKING/FETCH_FAILED',
                e
            });
        }
    });
}

export function* fetch_close_report() {
    yield* takeEvery("REPORTS/CLOSE/FETCH", function* (action) {
        try {
            const result = yield call(({ IdProperty, Day }) => {                
                return request.post(`${config.apiEndpoint}/api/v4/logic/close/day/${IdProperty}`)
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .send({ Day })
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { entries } = result;
                yield put({ type: 'REPORT/ENTRIES/SET', entries });
            } else {
                yield put({
                    type: 'REPORTS/CLOSE/FETCH_FAILED',
                    result
                });
            }
        } catch (e) {
            yield put({
                type: 'REPORTS/CLOSE/FETCH_FAILED',
                e
            });
        }
    });
}


// Piezas ocupadas (Checked-in) que pueden recibir cargos transferidos
export function* fetch_transfer_targets() {
    yield* takeEvery("TRANSFER_TARGETS/FETCH", function* (action) {
        try {
            const result = yield call(({ IdProperty, IdBook }) => {
                return request.get(`${config.apiEndpoint}/api/v4/accounting/transfer_targets/${IdProperty}`)
                    .query({ exclude: IdBook })
                    .set('auth_token', localStorage.getItem('legendbeds.authtoken'))
                    .then(data => (JSON.parse(data.text)));
            }, action);

            if (result && result.success) {
                const { targets } = result;
                yield put({ type: 'TRANSFER_TARGETS/SET', targets });
            } else {
                yield put({ type: 'TRANSFER_TARGETS/FETCH_FAILED', result });
            }
        } catch (e) {
            yield put({ type: 'TRANSFER_TARGETS/FETCH_FAILED', e });
        }
    });
}
